export const CONTACTS_SUCCESS = 'CONTACTS_SUCCESS';
export const GET_CONTACTS = 'GET_CONTACTS';